import script from "./HelmOpAppCoConfigTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelmOpAppCoConfigTab.vue?vue&type=script&setup=true&lang=ts"

import "./HelmOpAppCoConfigTab.vue?vue&type=style&index=0&id=f2ba9952&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2ba9952"]])

export default __exports__